import { FETCH_SELLER, SET_ERROR_SELLER } from './actions'

export const FetchSeller = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_SELLER,
        data: data,
      })
    } catch (err) {
      dispatch({
        type: SET_ERROR_SELLER,
        data: err.response,
      })
    }
  }
}
